import { render, staticRenderFns } from "./RecuperarTicket.vue?vue&type=template&id=290f9b2e&lang=pug&"
import script from "./RecuperarTicket.vue?vue&type=script&lang=js&"
export * from "./RecuperarTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports